import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';
import Header from '../../features/Header';
import Footer from '../../features/Footer';

const Checkout = React.lazy(() => import('../../views/Checkout'));

const params = [];
const CheckoutRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout header={<Header />} footer={<Footer />}>
        <Checkout />
      </Layout>
    </RouteParameter>
  );
};

CheckoutRoute.propTypes = {};

CheckoutRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(CheckoutRoute);
